'use strict';

import {sectionModel} from "../../models/sectionmodel.js";
import {fieldModel} from "../../models/fieldmodel.js";

export class SectionCtrl
{
	$scope;
	$filter;
	jsDataService;
	section = {};
	fieldCfg = {};
	childSections = {};
	
	constructor($scope, $filter, jsDataService){
		'ngInject';
		this.$scope = $scope;
		this.$filter = $filter;
		this.jsDataService = jsDataService;
		this.classif = this.jsDataService.get('cfgClassif', {});
		this.section = new sectionModel(jsDataService.get('sectionItem', {}), $filter, jsDataService);
		this.makeFieldCfg(this.section.fields);
	}
	
	makeFieldCfg(fields){
		if(typeof(fields) !== 'undefined'){
			for(let fld of Object.values(fields)){
				this.fieldCfg[fld.name] = new fieldModel(fld);
			}
		}
	}
	
	isField(name){
		return (typeof(this.fieldCfg[name]) !== 'undefined');
	}
	
	initChildSections(sections){
		if(typeof(sections) !== 'undefined'){
			for(let key in sections){
				this.childSections[key] = new sectionModel(sections[key], this.$filter, this.jsDataService);
				if(typeof(this.childSections[key].fields) !== 'undefined'){
					this.makeFieldCfg(this.childSections[key].fields);
				}
			}
		}
	}
	
	isSection(key){
		return (typeof(this.childSections[key]) !== 'undefined');
	}
	
	getSection(key){
		if(this.isSection(key)){
			return this.childSections[key];
		}
		return null;
	}
	
	isSectionInstruction(key, instructionName){
		let section = this.getSection(key);
		return (typeof(section.instructions) !== 'undefined' && typeof(section.instructions[instructionName]) !== 'undefined' && section.instructions[instructionName].value !== '');
	}
	
	getSectionInstruction(key, instructionName){
		if(this.isSectionInstruction(key, instructionName)){
			return this.getSection(key).instructions[instructionName].value;
		}
		return '';
	}
	
	autosavePostFields(){
		let post = [];
		if(this.section instanceof sectionModel){
			for(let fkey in this.section.fieldMap){
				post.push(this.section.fieldMap[fkey].getData());
			}
		}
		return post;
	}
	
	go2Url(urlString){
		console.log('go', urlString);
		this.$scope.goUrl(urlString);
	}
}